module.exports = {
    "Empty": `Vuoto`
};


//# sourceMappingURL=it-IT.main.js.map
